export const view = {
  namespaced: true,
  state: {
    isLogin: false,
    profileImageUrl: undefined,
    displayName: ''
  },
  mutations: {
    login (state) {
      state.isLogin = true
    },
    logout (state) {
      state.isLogin = false
      state.profileImageUrl = undefined
      state.displayName = ''
      state.uid = ''
    },
    setProfileImegeUrl (state, tmp) {
      state.profileImageUrl = tmp
    },
    setDisplayName (state, tmp) {
      state.displayName = tmp
    }
  },
  getters: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/view.js